import { useCallback } from 'react'
import { throttle, debounce } from '../utils/functions'

export const useThrottle = (fn: Function, delay: number, immediate?: boolean) => {
  const throttled = throttle(fn, delay, immediate)
  return useCallback(throttled, [fn, delay, immediate])
}

export const useDebounce = (fn: Function, delay: number, immediate?: boolean) => {
  const debounced = debounce(fn, delay, immediate)
  return useCallback(debounced, [fn, delay, immediate])
}
